import { render, staticRenderFns } from "./ButtonExport.vue?vue&type=template&id=32ad0198&scoped=true&functional=true&"
var script = {}
import style0 from "./ButtonExport.vue?vue&type=style&index=0&id=32ad0198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "32ad0198",
  null
  
)

export default component.exports